export default "__VITE_PUBLIC_ASSET__ce2efa2c__"